import { createContext, useContext } from 'react';

/**
 * The toast context, split out from `Toast.tsx`.
 *
 * A file that exports both a component and a hook breaks React Fast Refresh, so
 * the provider stays in `Toast.tsx` and the way to reach it lives here. This is
 * the ordinary React split, not a workaround.
 */

export interface ToastApi {
  success: (message: string) => void;
  error: (message: string) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

const NOOP: ToastApi = { success: () => {}, error: () => {} };

/**
 * Returns the toast API. Falls back to a no-op rather than throwing when there
 * is no provider, so a component rendered in isolation in a test does not need
 * one wrapped around it just to mount.
 */
export function useToast(): ToastApi {
  return useContext(ToastContext) ?? NOOP;
}
